import { useMutation } from '@apollo/client'
import DeleteIcon from '@material-ui/icons/Delete'
import { useState } from 'react'
import { toast } from 'react-toastify'

import { ConfirmActionModal } from '../../components/ConfirmActionModal'
import { ADD_ON_POLICY_DELETE } from '../../graphql/addOnPolicies'
import { getTranslate } from '../../localization'
import { AddOnPolicy } from '../../types/cancelAndModifyPolicies'
import RatePlansPoliciesActionModal from '../RatePlansPolicies/RatePlansPoliciesActionModal'
import useStyles from './styles/AddOnPoliciesTable.styles'

// The row's two dialogs (rules table, delete confirmation), shared by the desktop and mobile rows.
export const useAddOnPolicyRowActions = (
  data: AddOnPolicy,
  providerCode: string
) => {
  const classes = useStyles()
  const [tableIsOpen, setTableIsOpen] = useState(false)
  const [deleteIsOpen, setDeleteIsOpen] = useState(false)
  // Refetch the list by operation name so the deleted row disappears. Not awaited: the refetch
  // swaps the rows for skeletons, which unmounts this row, so the dialog must close before it.
  const [deletePolicy, { loading }] = useMutation(ADD_ON_POLICY_DELETE, {
    refetchQueries: ['AddOnPolicies']
  })

  const confirmDelete = async () => {
    try {
      const { data: response } = await deletePolicy({
        variables: { providerCode, policyID: data.basicDetails.id }
      })
      toast.success(response.deleteAddOnPolicy.message)
      setDeleteIsOpen(false)
    } catch (error) {
      // asset refuses while a rate plan still uses the set; its message says so.
      toast.error(error instanceof Error ? error.message : 'ERROR!')
    }
  }

  const dialogs = (
    <>
      <RatePlansPoliciesActionModal
        isOpen={tableIsOpen}
        onClose={() => setTableIsOpen(false)}
        data={data.table}
      />
      {deleteIsOpen && (
        <ConfirmActionModal
          icon={<DeleteIcon className={classes.deleteIcon} />}
          title={getTranslate('The policy is about to be deleted')}
          subtitle="Are you sure you want to delete it permanently?"
          signature="Delete Me"
          isOpen={deleteIsOpen}
          onClose={() => setDeleteIsOpen(false)}
          onClick={confirmDelete}
          loading={loading}
        />
      )}
    </>
  )

  return {
    openTable: () => setTableIsOpen(true),
    openDelete: () => setDeleteIsOpen(true),
    dialogs
  }
}
